import React from 'react'
import UserBadge from '../UserBadge/UserBadge'
import './UserDisplay.css'

const UserDisplay = ({
  user,
  usernameClass = '',
  showTitleBadges = true,
  showStatusBadges = true,
  inline = true,
  forceWhite = false,
  context = 'default'
}) => {
  if (!user) return null

  const isGM = user.is_gm
  const isIM = user.is_im
  const isWFM = user.is_wfm
  const isNM = user.is_nm
  const isPremiumAccount = user.account_type === 'premium'

  // Determine username class based on title (premium accounts have normal color, only star)
  const getUsernameColorClass = () => {
    if (forceWhite) return 'white-username'
    if (isGM) return 'gm-username'
    if (isNM) return 'nm-username'
    if (isIM) return 'im-username'
    if (isWFM) return 'wfm-username'
    return ''
  }

  return (
    <div className={`user-display ${inline ? 'inline' : 'stacked'}`}>
      {/* Title badges (GM/NM/IM/WFM) before username */}
      {showTitleBadges && (
        <div className="title-badges">
          {isGM && (
            <div className="user-badge gm-badge">GM</div>
          )}
          {isNM && (
            <div className="user-badge nm-badge">NM</div>
          )}
          {isIM && (
            <div className="user-badge im-badge">IM</div>
          )}
          {isWFM && (
            <div className="user-badge wfm-badge">WFM</div>
          )}
        </div>
      )}

      {/* Username with title-based coloring */}
      <span className={`username ${getUsernameColorClass()} ${usernameClass}`}>
        {user.username}
      </span>

      {/* Status badges (Premium/Streamer) after username */}
      {showStatusBadges && (
        <UserBadge
          user={user}
          showTitleBadges={false}
          showStatusBadges={true}
          context={context}
        />
      )}
    </div>
  )
}

export default UserDisplay